import { useLocation, useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { CONTACT, mailtoConsult } from "@/lib/contact";

export default function Footer() {
    const navigate = useNavigate();
    const location = useLocation();

    const goToSection = (href) => {
        if (location.pathname === "/") {
            scrollToId(href);
        } else {
            navigate(`/${href}`);
        }
    };

    return (
        <footer data-testid="footer" className="border-t border-white/10 px-4 sm:px-8 lg:px-16 py-12 bg-[#0E121B]/60">
            <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                <div>
                    <img src="/salescan-logo.png" alt="SalesCan" className="h-8 w-auto mb-3" />
                    <p className="text-sm text-slate-500 max-w-xs">
                        Sales performance engineering for ambitious businesses. Analytics,
                        automations and AI — built in Canada.
                    </p>
                    <p className="text-sm text-slate-500 mt-3">{CONTACT.address}</p>
                    <a href={mailtoConsult} className="block text-sm text-slate-400 hover:text-white mt-2">{CONTACT.email}</a>
                    <a href={`tel:${CONTACT.phoneTel}`} className="block text-sm text-slate-400 hover:text-white">{CONTACT.phoneDisplay}</a>
                </div>
                <div className="flex flex-wrap items-center gap-6">
                    {[
                        { label: "Services", href: "#services" },
                        { label: "Process", href: "#process" },
                        { label: "Impact", href: "#impact" },
                    ].map((l) => (
                        <button
                            key={l.href}
                            data-testid={`footer-link-${l.label.toLowerCase()}`}
                            onClick={() => goToSection(l.href)}
                            className="font-mono-tech text-xs uppercase tracking-[0.2em] text-slate-400 hover:text-white transition-colors duration-300"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="footer-cta-button"
                        onClick={() => goToSection("#contact")}
                        className="group flex items-center gap-2 text-xs font-semibold text-[#FF3B30] hover:text-[#ff5147] uppercase tracking-[0.2em] transition-colors duration-300"
                    >
                        Book a call
                        <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </button>
                </div>
            </div>
            <div className="max-w-[1400px] mx-auto mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3">
                <p className="text-xs text-slate-600">© {new Date().getFullYear()} SalesCan. All rights reserved.</p>
                <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-slate-600">
                    Sell faster. Close smarter.
                </p>
            </div>
        </footer>
    );
}
